import { API } from "@/lib/api";
import { User } from "@/contexts/UserContext";

export function resyncSellerData() {
  return API.post<Partial<User>>(`/sync`, {}, new URLSearchParams({ force: "true" }));
}

export function resyncAllSalesData() {
  return API.post<Partial<User>>(`/sync-all-sales`, {});
}